"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselProgress = exports.CarouselPlayButton = exports.CarouselDots = exports.CarouselButton = exports.CarouselComponent = void 0;
var carousel_1 = require("./carousel");
Object.defineProperty(exports, "CarouselComponent", { enumerable: true, get: function () { return carousel_1.CarouselComponent; } });
var carousel_button_1 = require("./carousel-button");
Object.defineProperty(exports, "CarouselButton", { enumerable: true, get: function () { return carousel_button_1.CarouselButton; } });
var carousel_dots_1 = require("./carousel-dots");
Object.defineProperty(exports, "CarouselDots", { enumerable: true, get: function () { return carousel_dots_1.CarouselDots; } });
var carousel_play_button_1 = require("./carousel-play-button");
Object.defineProperty(exports, "CarouselPlayButton", { enumerable: true, get: function () { return carousel_play_button_1.CarouselPlayButton; } });
var carousel_progress_bar_1 = require("./carousel-progress-bar");
Object.defineProperty(exports, "CarouselProgress", { enumerable: true, get: function () { return carousel_progress_bar_1.CarouselProgress; } });
